import { createStylesParam, StyleParamType } from '@wix/tpa-settings';

export const settings = {};

export const styles = {
  showMembersBadges: createStylesParam('showMembersBadges', {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  }),
};
